
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition de Facing : Guide Complet pour Comprendre ce Terme Architectural",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition précise du terme 'facing'. Une explication claire et complète pour comprendre parfaitement ce concept complexe.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition de Facing : Guide Complet pour Comprendre ce Terme Architectural",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition précise du terme 'facing'. Une explication claire et complète pour comprendre parfaitement ce concept complexe.",
        },
      ],
    };
  },
};
